<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-radio-button-view
      @change="updateValue"
      :checkbox="saveData"
      :valid="valid"
      :validate="validate"
      :nid="nid"
    />
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Radio'"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
      @collapse-click="collapsePreview"
    />
    <md-content v-show="!collapse">
      <fb-radio-button-view :checkbox="saveData" />
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <fb-radio-button-option
          @save-option="saveOptions('options', $event)"
          :options="tempData.options"
          :value="tempData.value"
        />
        <md-checkbox v-model="tempData.other">Other Field</md-checkbox>
        <div v-if="tempData.other">
          <md-field>
            <label>Other Label</label>
            <md-input v-model="tempData.other_label"></md-input>
          </md-field>
        </div>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbRadioButtonOption from "./FbRadioButtonOption";
import FbRadioButtonView from "./FbRadioButtonView";

export default {
  name: "FbRadioButton",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      let value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.saveData.value = value.value;
      this.saveData.other_text = value.other_text;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true &&
              (!this.saveData.value || (this.saveData.value == 'other' && this.saveData.other_text.length == 0) || this.saveData.value.length == 0));
      return val;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: {
            value: this.saveData.value,
            other_text: this.saveData.other_text
          },
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  data() {
    return {
      showDialog: false,
      tempData: {
        other: this.element.data.other || false,
        other_label: this.element.data.other_label || "Enter other",
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        value: this.element.data.value || "",
        other_text: "",
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false
      },
      saveData: {
        other: this.element.data.other || false,
        other_label: this.element.data.other_label || "Enter other",
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        value: this.element.data.value || "",
        other_text: "",
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false
      }
    };
  },
  methods: {
    updateValue(value) {
      this.saveData.value = value.value;
      this.saveData.other_text = value.other_text;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    selectRadio(value) {
      this.tempData.value = value[0];
    },
    saveOptions: function saveOptions(type, data) {
      this.tempData[type] = data;
    }
  },
  components: {
    FbRadioButtonOption,
    FbRadioButtonView
  }
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
